export default "__VITE_PUBLIC_ASSET__93ce25ec__"